import { render, staticRenderFns } from "./notice-field.vue?vue&type=template&id=063859f8&"
import script from "./notice-field.vue?vue&type=script&lang=js&"
export * from "./notice-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports